import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../styles/common.css";
import "../styles/legal.css";

const CookiePolicy = () => {

  return (
    <>
      <Navbar></Navbar>
      <main className='cookiePolicy'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>Cookie Policy</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/">Home</a></li>
                <li aria-current="page">Cookie Policy</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='legal'>
          <div className='legal-box'>
            <h2>1. Einleitung</h2>
            <div className='legal-box__text'>
              <p>Diese Cookie-Richtlinie erklärt, wie <b>LOGOT UG</b> ("wir", "uns" oder "unser") Cookies und ähnliche Technologien auf unserer Website verwendet werden. Durch die Nutzung unserer Website stimmen Sie der Verwendung von Cookies gemäß dieser Richtlinie zu.</p>
            </div>
          </div>

          <div className='legal-box'>
            <h2>2. Was sind Cookies?</h2>
            <div className='legal-box__text'>
              <p>Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden, wenn Sie eine Website besuchen. Sie helfen uns, Ihre Präferenzen zu speichern, die Benutzerfreundlichkeit zu verbessern und statistische Daten zu erheben.</p>
            </div>
          </div>

          <div className='legal-box'>
            <h2>3. Welche Arten von Cookies verwenden wir?</h2>
            <div className='legal-box__text'>
              <p>Wir verwenden die folgenden Arten von Cookies:</p>
              <ul className='list-disc'>
                <li><b>Notwendige Cookies:</b> Erforderlich für den Betrieb der Website (z. B. Session-Cookies, Sicherheits Cookies).</li>
                <li><b>Funktionale Cookies:</b> Speichern Benutzereinstellungen (z. B. Sprache, Anmeldeinformationen).</li>
                <li><b>Analytische Cookies:</b> Helfen uns, das Nutzerverhalten zu analysieren (z. B. Google Analytics, Matomo).</li>
                <li><b>Marketing- und Tracking-Cookies:</b> Werden verwendet, um personalisierte Werbung und Inhalte anzuzeigen.</li>
              </ul>
            </div>
          </div>

          <div className='legal-box'>
            <h2>4. Rechtsgrundlage für die Verwendung von Cookies</h2>
            <div className='legal-box__text'>
              <p>Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten durch Cookies hängt von der Art des verwendeten Cookies ab:</p>
              <ul className='list-disc'>
                <li><b>Notwendige Cookies:</b> Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO).</li>
                <li><b>Funktionale, analytische und Marketing-Cookies:</b> Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).</li>
              </ul>
            </div>
          </div>

          <div className='legal-box'>
            <h2>5. Verwaltung und Ablehnung von Cookies</h2>
            <div className='legal-box__text'>
              <p>Sie können Ihre Cookie-Einstellungen jederzeit über unser Cookie-Banner oder die Einstellungen Ihres Browsers anpassen. Hier sind einige Anleitungen zur Deaktivierung von Cookies in gängigen Browsern:</p>
              <ul className='list-disc'>
                <li><a href="https://support.google.com/chrome/answer/95647" className='button-underLine' target="_blank">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen" className='button-underLine' target="_blank">Mozilla Firefox</a></li>
                <li><a href="https://support.microsoft.com/de-de/help/4027947/microsoft-edge-delete-cookies" className='button-underLine' target="_blank">Microsoft Edge</a></li>
                <li><a href="https://support.apple.com/de-de/guide/safari/sfri11471/mac" className='button-underLine' target="_blank">Apple Safari</a></li>
              </ul>
              <p>Bitte beachten Sie, dass das Deaktivieren von Cookies die Funktionalität unserer Website einschränken kann.</p>
            </div>
          </div>

          <div className='legal-box'>
            <h2>6. Änderungen dieser Cookie-Richtlinie</h2>
            <div className='legal-box__text'>
              <p>Wir behalten uns das Recht vor, diese Cookie-Richtlinie jederzeit zu ändern. Die aktuelle Version ist stets auf unserer Website verfügbar.</p>
              <p><b>Letzte Aktualisierung: 01.03.2025</b></p>
            </div>
          </div>
        </section>

      </main >
      <Footer></Footer>
    </>
  );
};

export default CookiePolicy